/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createStagingAllotmentFromDiscriminatorValue, type Allotment, type ProblemDetails, type StagingAllotment } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingAllotment/InsertSelectedAllotments
 */
export interface InsertSelectedAllotmentsRequestBuilder extends BaseRequestBuilder<InsertSelectedAllotmentsRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Allotment[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {StagingAllotment} error when the service returns a 422 status code
     * @throws {ProblemDetails} error when the service returns a 4XX or 5XX status code
     */
     post(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Allotment[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InsertSelectedAllotmentsRequestBuilderUriTemplate = "{+baseurl}/StagingAllotment/InsertSelectedAllotments";
/**
 * Metadata for all the requests in the request builder.
 */
export const InsertSelectedAllotmentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: InsertSelectedAllotmentsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            422: createStagingAllotmentFromDiscriminatorValue as ParsableFactory<Parsable>,
            XXX: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createAllotmentFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestInformationContentSetMethod: "setContentFromScalar",
    },
};
/* tslint:enable */
/* eslint-enable */
